/* global gtag */

export default {
  handle(...params) {
    if (typeof gtag === 'undefined') {
      return;
    }

    gtag.apply(this, params);
  },

  event(category, action, label, value = 0) {
    this.handle('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  },

  timing(category, value) {
    this.handle('event', 'timing_complete', {
      name: 'load',
      value,
      event_category: category,
    });
  },
};
